/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Component, OnInit } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IsbPackageComponent } from '../isb-package/isb-package.component';
import {Router} from '@angular/router';




@Component({
    selector: 'app-isb',
    templateUrl: './isb.component.html',
    styleUrls: ['./isb.component.scss'],
    standalone: false
})
export class IsbComponent implements OnInit {

  breadcrumbItems: BreadcrumbItem[] = [];
  tenant: string;

  constructor(private authService: AuthService, private sidenavService: SidenavService, private router: Router) { }

  ngOnInit(): void {
   this.transalte();
  }

  transalte(): void {
    this.sidenavService.selectedMenu = 'LEFT_SIDE_NAV.INITIAL_SYSTEM_BUILDS';
    this.tenant = this.authService.principal.provider;
    this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg'},
      {label: translate('LEFT_SIDE_NAV.VIEW_REQUEST')},
      {label: translate('LEFT_SIDE_NAV.INITIAL_SYSTEM_BUILDS'), url: ['isb']});
  }

  addNewPackage() {
    this.router.navigate(['/',this.authService.principal.provider, 'isb','isbPackages']);
};

}
